import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { useMemo } from "react";
import Loading from "@/components/Loading";
import MetaTags from "@/components/MetaTags/index";
import { useAdultModeQuery } from "@/hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Canvas = dynamic(function () {
  return import("@/components/Canvas");
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@/components/Canvas")];
    }
  }
});
/**
 * getIdKey.
 *
 * @param {string} slug
 * @param {boolean} adultMode
 */

function getIdKey(slug, adultMode) {
  if (adultMode) {
    return "canvas_".concat(slug, "_adult");
  } else {
    // slugの末尾に_adultがついていた場合は404にする
    if (/_adult$/.test(slug)) {
      return "";
    }

    return "canvas_".concat(slug);
  }
}

export var __N_SSP = true;
export default function CanvasPage(_ref) {
  var title = _ref.title,
      metatags = _ref.metatags;
  var router = useRouter();

  var _useAdultModeQuery = useAdultModeQuery({
    fetchPolicy: "cache-first"
  }),
      loading = _useAdultModeQuery.loading,
      data = _useAdultModeQuery.data;

  var adultMode = data === null || data === void 0 ? void 0 : data.adultMode;
  var key = useMemo(function () {
    return getIdKey(router.query.slug, adultMode);
  }, [router, adultMode]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MetaTags, _objectSpread({}, metatags)), loading && /*#__PURE__*/_jsx(Loading, {
      fixed: true
    }), !loading && /*#__PURE__*/_jsx(Canvas, {
      idKey: key,
      title: title
    })]
  });
}